import React from 'react';
import { BsCheckCircleFill, BsXLg } from 'react-icons/bs';
import styles from './AddedEmployeesList.module.scss';

const InvitedRow = ({ employee, onRemove }) => {
  const initial = employee.name ? employee.name.charAt(0).toUpperCase() : '?';
  const tags = [employee.team, employee.role, employee.timeZone].filter(
    Boolean
  );

  return (
    <div className={styles.invitedRow}>
      <div className={styles.invitedRowAvatar}>{initial}</div>
      <div className={styles.invitedRowMeta}>
        <span className={styles.invitedRowName}>{employee.name}</span>
        <span className={styles.invitedRowEmail}>{employee.email}</span>
      </div>
      <div className={styles.invitedRowTags}>
        {tags.map((tag) => (
          <span key={tag} className={styles.invitedTag}>
            {tag}
          </span>
        ))}
      </div>
      <div className={styles.invitedRowStatus}>
        <BsCheckCircleFill size={14} />
        <span>Added</span>
      </div>
      <button
        type="button"
        className={styles.invitedRowRemoveBtn}
        onClick={onRemove}
        aria-label="Remove employee"
      >
        <BsXLg size={11} />
      </button>
    </div>
  );
};

/**
 * Review list of employees added so far in a multi-step "add employee"
 * flow — a row per employee with tags (department/role/timezone) and a
 * remove action.
 */
export const AddedEmployeesList = ({
  employees,
  onRemove,
  title = 'Added Employees',
  subtitle = 'Track the status of your invitations.',
}) => {
  if (!employees.length) return null;

  return (
    <div className={styles.invitedSection}>
      <h3 className={styles.invitedSectionTitle}>
        {title} ({employees.length})
      </h3>
      <p className={styles.invitedSectionSubtitle}>{subtitle}</p>
      <div className={styles.invitedList}>
        {employees.map((emp, i) => (
          <InvitedRow key={i} employee={emp} onRemove={() => onRemove(i)} />
        ))}
      </div>
    </div>
  );
};
